import React, { useRef } from 'react';
import { BasicModal, Text, Button } from '@doda/io-react/common';
import { SavedSearchRequest } from '@doda/api-client/aspida/@types';
import { selectSearchCondition } from 'logics/selectOverwriteCondition';
import styles from './index.module.scss';
import { overwriteOldestCondition } from './logics/overwriteOldestCondition';

/**
 * OverwriteConditionModalコンポーネントのProps
 */
interface Props {
  /** モーダルを閉じるためのハンドラー */
  onClickClose: () => void;
  /** 上書きボタンがクリックされた時のハンドラー（任意） */
  onOverwrite?: () => void;
  /** 条件選択ボタンがクリックされた時のハンドラー（任意） */
  onSelectCondition?: () => void;
  /** 保存された検索条件 */
  conditions: Omit<SavedSearchRequest, 'name'>;
  /** 古いアクション（任意） */
  oldAction?: string;
  /** リダイレクトURL（任意） */
  redirectUrl?: string;
}

/**
 * OverwriteConditionModalコンポーネント
 * 検索条件の上書きを確認するモーダル
 * @param {Props} props - コンポーネントのプロパティ
 * @returns {JSX.Element} OverwriteConditionModalのJSX要素
 */
export const OverwriteConditionModal: React.FC<Props> = ({
  onClickClose,
  onOverwrite,
  onSelectCondition,
  conditions,
  oldAction,
  redirectUrl,
}) => {
  const isClickedRef = useRef(false);

  /**
   * 上書きボタンのクリックイベントハンドラー
   */
  const onClickOverWrite = () => {
    if (isClickedRef.current) return;
    isClickedRef.current = true;
    onOverwrite?.();
    overwriteOldestCondition({ conditions, redirectUrl });
  };

  /**
   * 条件選択ボタンのクリックイベントハンドラー
   */
  const onClickSelectConditions = () => {
    onSelectCondition?.();
    selectSearchCondition({ conditions, action: oldAction });
  };

  return (
    <BasicModal width={450} onClickClose={onClickClose} show title="上書き確認">
      <div className={styles.overwriteConditionModal}>
        <Text size="16" color="red_pc">
          検索条件の登録は最大5件です。
        </Text>
        <Text size="16">
          上限を超えているため、一番保存日が古い検索条件に
          <br />
          上書きしますか？
        </Text>
        <div className={styles.overwriteConditionModal__buttonWrapper}>
          <Button onClick={onClickOverWrite} variant="green">
            上書きする
          </Button>
          <Button onClick={onClickSelectConditions} variant="outline_blue">
            上書きする条件を選択する
          </Button>
        </div>
      </div>
    </BasicModal>
  );
};
